export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 3,
        name_ca: 'Simple',
        name_es: 'Simple',
        name_en: 'Simple glazing'
    }, {
        id: 4,
        name_ca: 'Doble',
        name_es: 'Doble',
        name_en: 'Double glazing'
    }, {
        id: 5,
        name_ca: 'Doble amb càmera',
        name_es: 'Doble con cámara',
        name_en: 'Double glazing with camera'
    }, {
        id: 6,
        name_ca: 'Triple amb doble càmera',
        name_es: 'Triple con doble cámara',
        name_en: 'Triple glazing with double camera'
    }
]





// WEBPACK FOOTER //
// ./src/options/glazings.js